import { getMyNotifications } from "api/notifications";
import type { NotificationDto } from "api/types";
import { useEffect, useState } from "react";
import { useSession } from "Session";

/**
 * Unread notification count for the sidebar. It lives here rather than in the notifications nav item
 * because the collapsed phone menu also flags it on the toggle, and both must share one lookup.
 */
export const useUnreadNotifications = (): number => {
	const { getAccessToken } = useSession();
	const [unreadCount, setUnreadCount] = useState(0);

	useEffect(() => {
		let isCurrent = true;

		const load = async (): Promise<void> => {
			const token = await getAccessToken();
			if (!token || !isCurrent) {
				return;
			}

			const loaded = await getMyNotifications(token);
			if (!isCurrent) {
				return;
			}

			setUnreadCount(loaded.filter((notification: NotificationDto) => !notification.isRead).length);
		};

		load().catch(() => undefined);

		return () => {
			isCurrent = false;
		};
	}, [getAccessToken]);

	return unreadCount;
};
